import * as React from "react";
import clsx from "clsx";
import Icon from "../icon";
import Button from "../button";
import * as styles from "./icon-button.css";
import type { IconButtonProps } from "./icon-button.types";

function IconButton(props: IconButtonProps) {
  return (
    <Button
      attributes={{
        ...props.attributes,
        borderRadius: props.isRound ? "$full" : undefined,
      }}
      variant={props.variant}
      intent={props.intent}
      size={props.size}
      disabled={props.disabled}
      onClick={(e) => props.onClick?.(e)}
      onHoverStart={(e) => props.onHoverStart?.(e)}
      onHoverEnd={(e) => props.onHoverEnd?.(e)}
      className={clsx(styles.container, props.className)}
    >
      <Icon name={props.icon} size={props.iconSize} />
    </Button>
  );
}

export default IconButton;
